import {
  Badge,
  Box,
  Button,
  Center,
  HStack,
  Icon,
  Input,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Title } from "../../components/Title";
import { Grid, WindowScroller, InfiniteLoader } from "react-virtualized";
import { MediaLibraryForm } from "../../forms";
import {
  MediaLibraryItemsDocument,
  MediaLibraryItemsQuery,
  useCreateMediaLibraryItemMutation,
  useMediaLibraryItemsLazyQuery,
} from "../../graphql";
import { Loader } from "../../components/Loader";
import { Img } from "react-image";
import VisibilitySensor from "react-visibility-sensor";
import { MdImage } from "react-icons/md";

interface MediaGridProps {
  data: MediaLibraryItemsQuery;
  loading: Boolean;
  forceHeight?: number;
}
const MediaGrid = (props: MediaGridProps) => {
  //   if (props.loading) {
  //     return <Loader />;
  //   }

  const { data } = props;
  const totalItems = data?.mediaLibraryItems?.totalCount || 0;
  const nodes = data?.mediaLibraryItems?.nodes || [];
  const columnCount = 3;
  const rowCount = Math.ceil(nodes.length / columnCount);
  const width = 700;
  const toast = useToast();

  const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
    const itemIndex = rowIndex * columnCount + columnIndex;
    const item = nodes[itemIndex];

    if (!item) {
      return null;
    }

    return (
      <div key={key} style={style}>
        <Box
          maxW={"210px"}
          borderWidth="1px"
          borderRadius="lg"
          overflow="hidden"
          key={key}
        >
          <VisibilitySensor>
            <Img
              src={item.thumbnail.url}
              alt={item.title}
              style={{
                maxHeight: "140px",
                width: "210px",
                objectFit: "cover",
              }}
              loader={
                <>
                  <Center
                    width={210}
                    height={140}
                    background="blue.50"
                    color="blue.400"
                  >
                    <Icon as={MdImage} fontSize={50} />
                  </Center>
                </>
              }
            />
          </VisibilitySensor>

          <Box p="6">
            <Box display="flex" alignItems="baseline">
              {item.thumbnail.contentType.startsWith("image") ? (
                <Tooltip
                  label={
                    "Kliko mbi simbolin e madhësisë për të kopjuar adresën URL në rezolucionin e dëshiruar."
                  }
                  shouldWrapChildren={true}
                >
                  <Box
                    cursor={"pointer"}
                    color="gray.500"
                    fontWeight="semibold"
                    letterSpacing="wide"
                    fontSize="xs"
                    textTransform="uppercase"
                    ml="2"
                  >
                    <HStack>
                      <Badge borderRadius="full" px="2" colorScheme="teal">
                        URL
                      </Badge>
                      <Tag
                        onClick={() => {
                          navigator.clipboard.writeText(item.thumbnail.url);

                          toast({
                            status: "success",
                            title: "Sukses",
                            description: "Adresa u kopjua",
                          });
                        }}
                      >
                        S
                      </Tag>
                      <Tag
                        onClick={() => {
                          navigator.clipboard.writeText(item.medium.url);

                          toast({
                            status: "success",
                            title: "Sukses",
                            description: "Adresa u kopjua",
                          });
                        }}
                      >
                        M
                      </Tag>
                      <Tag
                        onClick={() => {
                          navigator.clipboard.writeText(item.large.url);

                          toast({
                            status: "success",
                            title: "Sukses",
                            description: "Adresa u kopjua",
                          });
                        }}
                      >
                        L
                      </Tag>
                    </HStack>
                  </Box>
                </Tooltip>
              ) : null}
            </Box>

            <Box
              mt="1"
              fontWeight="semibold"
              as="h4"
              lineHeight="tight"
              noOfLines={1}
            >
              {item.title}
            </Box>
          </Box>
        </Box>
      </div>
    );
  };

  return (
    <WindowScroller>
      {({ height, isScrolling, registerChild, scrollTop }) => (
        <Grid
          ref={registerChild}
          cellRenderer={cellRenderer}
          columnCount={columnCount}
          columnWidth={230}
          height={props.forceHeight ? props.forceHeight : height}
          isScrolling={isScrolling}
          rowCount={rowCount}
          rowHeight={250}
          width={width}
          autoWidth={true}
          //   autoHeight={true}
        />
      )}
    </WindowScroller>
  );
};

interface MediaLibraryProps {
  batchSize?: number;
  forceHeight?: number;
}

export const MediaLibrary: React.FC<MediaLibraryProps> = ({
  batchSize = 20,
  forceHeight = 0,
}) => {
  const pageSize = batchSize;
  const [search, setSearch] = useState("");
  const [pageLimit, setPageLimit] = useState(pageSize);

  const [activeIndex, setActiveIndex] = useState(0);
  const [createMediaLibraryItem, { loading: loadingMediaLibrary }] =
    useCreateMediaLibraryItemMutation();

  const [loadMediaLibraryItems, { data, loading }] =
    useMediaLibraryItemsLazyQuery();

  useEffect(() => {
    // alert(pageLimit);
    loadMediaLibraryItems({
      variables: {
        search: search,
        page: 1,
        pageLimit: pageLimit,
      },
    });
  }, [loadMediaLibraryItems, pageLimit, search]);

  return (
    <>
      <Tabs index={activeIndex} onChange={(index) => setActiveIndex(index)}>
        <TabList>
          <Tab>Galeria</Tab>
          <Tab>Ngarko</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Stack spacing={3} mb={5}>
              <Input
                placeholder="Kërko"
                size="md"
                onChange={(ev) => setSearch(ev?.target?.value)}
              />
            </Stack>
            <MediaGrid
              data={data}
              loading={loading}
              forceHeight={forceHeight}
              // onLoadMore={() => {
              //   setPageLimit((limit) => limit + pageSize);
              // }}
            />
            {data?.mediaLibraryItems?.pageInfo?.hasNextPage && (
              <Center>
                <Button
                  onClick={() => {
                    setPageLimit((limit) => limit + pageSize);
                  }}
                >
                  Ngarko më tepër
                </Button>
              </Center>
            )}
          </TabPanel>
          <TabPanel>
            <MediaLibraryForm
              initialValues={{
                title: "",
                media: {
                  key: "",
                  url: "",
                },
              }}
              onSubmit={async (data) => {
                await createMediaLibraryItem({
                  variables: {
                    title: data.title,
                    mediaKey: data.media.key,
                  },
                  refetchQueries: [
                    {
                      query: MediaLibraryItemsDocument,
                      variables: {
                        search: search,
                        page: 1,
                        pageLimit: pageLimit,
                      },
                    },
                  ],
                });

                setActiveIndex(0);
              }}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

const MediaLibraryPage: React.FC = () => {
  return (
    <>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={2}
        background="white"
      >
        <Title title="Libraria e mediave"></Title>
        <MediaLibrary />
      </Box>
    </>
  );
};

export default MediaLibraryPage;
